import React, { Component, PropTypes } from "react"
import { Switch, Row, Menu, Dropdown, Icon, message, Input, Form } from "antd"
import { clearToken } from "app/api/localTools"
import config from "app/config"
import "./Index.scss"
import headerpic from "app/styles/images/sp/title.svg"
import stores from "app/stores"
import cx from "classnames"
import { Link } from "react-router-dom"
import { inject, observer } from "mobx-react"
import dataWarningIcon from "app/styles/images/sp/data-warning.svg"
import closeIcon from "app/styles/images/sp/close.svg"
import lockIcon from "app/styles/images/sp/lock.svg"
import forbiddenIcon from "app/styles/images/sp/dialogue.svg"
import MaterialModal from "app/components/normal/MaterialModal"
import MaterialFormItem from "app/components/normal/MaterialFormItem/MaterialFormItem"
import MaterialForm from "app/components/normal/MaterialForm/MaterialForm"
import SwitchApp from "app/components/common/SwitchApp/SwitchApp"

@inject("auth")@observer
export default class Header extends Component{
  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  constructor(props){
    super(props)
    this.state = {
      passwordModalVisible : false,
      showSafeCenter: false,
      showAutoExit: false,
      userSetting: {},
      bindInfoData: {
        phone: "",
        code: "",
      },
      showBindInfo: false,
      waitSecond: 60,
      isReadySendCode: true,
      legitimacy: {
        phone: {
          tipMsgType: "",
        },
        code: {
          tipMsgType: ""
        }
      }
    }
  }

  logOut = (e) => {
    clearToken()
    window.location.href = `${config.urlPrefix}/start/login`
  }

  showEditPsdModal = ()=>{
    this.setState({
      passwordModalVisible: true
    })
  }

  showBindInfoModal = () => {
    this.setState({
      showBindInfo: true
    })
  }

  nullClick = ()=>{
    return false
  }

  showSafeCenter = () => {
    const { auth } = this.props

    auth.getUserSetting()
    .then(
      res => {
        this.setState({
          userSetting: res,
          showSafeCenter: true
        })
      }
    )
  }

  showAutoExit = () => {
    this.setState({
      showAutoExit: true
    })
  }

  closeModal = (modal) => {
    if (modal === "showBindInfo") {
      const { phone } = this.state.bindInfoData
      this.setState({
        [modal]: false,
        bindInfoData: {
          phone: phone,
          code: "",
        },
        legitimacy: {
          phone: {
            tipMsgType: "",
          },
          code: {
            tipMsgType: ""
          }
        },
      })
      return
    }

    this.setState({
      [modal]: false
    })
  }

  changeTimeOutLock = () => {
    const { auth } = this.props
    const { userSetting } = this.state
    const newUserSetting = {
      ...userSetting,
      "timeoutLock": !userSetting.timeoutLock
    }

    auth.updateUserSetting(newUserSetting)
    .then(
      res => {
        this.setState({
          userSetting: newUserSetting,
        })
      },
      err => {
        message.error("开启/禁用自动锁屏失败")
      }
    )
  }

  changeBindInfoData = (e, field) => {
    this.setState({
      bindInfoData: {
        ...this.state.bindInfoData,
        [field]: e.target.value
      }
    })
  }

  changeAutoExit = () => {
    let { userSetting } = this.state
    if (userSetting.autoExit) {
      this.closeAutoExit()
    } else {
      this.showAutoExit()
    }
  }

  openAutoExit= () => {
    const { auth } = this.props
    const { userSetting } = this.state
    const newUserSetting = {...userSetting, "autoExit": !userSetting.autoExit }
    auth.updateUserSetting(newUserSetting)
    .then(
      res => {
        this.setState({
          showAutoExit: false,
          userSetting: newUserSetting,
        })
      },
      err => {
        message.error("开启/禁用会话保持失败")
      }
    )
  }

  closeAutoExit = () => {
    const { auth } = this.props
    const { userSetting } = this.state
    const newUserSetting = {...userSetting, "autoExit": !userSetting.autoExit }
    auth.updateUserSetting(newUserSetting)
    .then(
      res => {
        this.setState({
          showAutoExit: false,
          userSetting: newUserSetting,
        })
      },
      err => {
        message.error("开启/禁用会话保持失败")
      }
    )
  }

  sendCode = () => {
    let { isReadySendCode, bindInfoData } = this.state
    let isLegitimacy = this.checkLegitimacy("phone")
    const { sendVerifyCode } = this.props.auth
    if(isReadySendCode && isLegitimacy){
      // 发送验证码接口
      sendVerifyCode(bindInfoData.phone)
      .then(
        res => {
          message.success("验证码发送成功")
          this.setState({
           isReadySendCode: false
          })
          this.interval = setInterval(() => {
           this.changeCountDown()
          }, 1000)
        },
        err => {
          message.error(err)
        }
      )

    }
  }

  changeCountDown = () => {
    if(this.state.waitSecond <= 0){
      clearInterval(this.interval)
      this.setState({
        waitSecond: 60,
        isReadySendCode: true,
      })
    }
    this.setState({
      waitSecond: this.state.waitSecond - 1
    })
  }

  checkLegitimacy = (field) => {
    const { legitimacy, bindInfoData } = this.state
    let reg = {}
    reg.code = /^\d{6}$/
    reg.phone = /^1[34578]\d{9}$/

    if ((bindInfoData[field] || " ").trim() === "") { // 输入为空的提示
      this.setState({
        legitimacy: {
          ...legitimacy,
          [field]: {
            ...legitimacy[field],
            "tipMsgType": "empty"
          }
        }
      })
      return false
    }

    if (!reg[field].test(bindInfoData[field])) {  // 合法性提示
      this.setState({
        legitimacy: {
          ...legitimacy,
          [field]: {
            ...legitimacy[field],
            "tipMsgType": "error"
          }
        }
      })
      return false
    }

    this.setState({   // 清空错误提示
      legitimacy: {
        ...legitimacy,
        [field]: {
          ...legitimacy[field],
          "tipMsgType": ""
        }
      }
    })
    return true
  }

  clearLegitimacyError = (field) => {
    const { legitimacy } = this.state
    this.setState({
      legitimacy: {
        ...legitimacy,
        [field]: {
          ...legitimacy[field],
          "tipMsgType": ""
        }
      }
    })
  }

  confirmBind = () => {
    // 调用接口
    const { bindInfoData } = this.state
    const { bindPhone, loadUserInfo } = this.props.auth
    bindPhone(bindInfoData)
    .then(
      res => {
        loadUserInfo()
        message.success("手机号绑定成功")
      },
      err => {
        message.error("手机号绑定失败")
      }
    )
  }

  render()
  {
    let { userInfo } = stores.auth
    let { userSetting, bindInfoData, waitSecond, isReadySendCode, legitimacy, passwordModalVisible } = this.state
    const menu = (
      <Menu selectable={false}>
        <Menu.Item key="1">
          <a  onClick={(e)=>this.showBindInfoModal()}><Icon type="user" />  账户信息</a>
        </Menu.Item>
        <Menu.Item key="2">
          <a  onClick={(e)=>this.showEditPsdModal()}><Icon type="unlock" />  修改密码</a>
        </Menu.Item>
        <Menu.Item key="4">
          <a  onClick={this.showSafeCenter}><Icon type="safety" />  安全中心</a>
        </Menu.Item>
        <Menu.Item key="3">
          <a  onClick={(e)=>this.logOut()}><Icon type="poweroff" />  退出登录</a>
        </Menu.Item>
      </Menu>
    )
    const codeBtnClass = cx({
      "code-btn": true,
      "disable": !isReadySendCode,
      "cursor-p": isReadySendCode,
    })
    return (
        <header className="page-header page-header-back">
          <Link className="page-header-logo" to="/public/start/apps">
            <div>
            </div>
          </Link>
          <SwitchApp location={this.props.location} className="page-header-auth" />
          <ul className="page-header-nav">
            <li>
              <a>
                <Icon type="question-circle-o" />
                常见问题
              </a>
            </li>
            <li>
              <a>
                <Icon type="exclamation-circle-o" />
                帮助中心
              </a>
            </li>
            <li>
              <a>
                <Icon type="message" />
                问题反馈
              </a>
            </li>
            <li>
              <Dropdown overlay={menu}>
                <a className="ant-dropdown-link" onClick={this.nullClick}>
                  <span className="header-user-img ">
                    <img alt="" src={headerpic} />
                  </span>
                  {userInfo.truename}<Icon type="down" />
                </a>
              </Dropdown>
            </li>
          </ul>
          {passwordModalVisible &&
            <ChangePasswordModal onClose={() => this.setState({passwordModalVisible: false})}/>
          }
          <MaterialModal
            className="safe-center-modal"
            title="安全中心"
            visible={this.state.showSafeCenter}
            footer={null}
            width={640}
          >
            <img
              className="pgx-modal-close"
              src={closeIcon}
              alt="关闭对话框"
              onClick={()=>this.closeModal("showSafeCenter")}
            />
            <Row className="piece">
              <img src={lockIcon} alt="" />
              <div className="view">
                <div className="title">无操作自动锁屏</div>
                <div>15分钟对页面无任何操作，需重新登录</div>
              </div>
              <Switch
                className="switch"
                checked={userSetting.timeoutLock}
                onChange={this.changeTimeOutLock} />
            </Row>
            <Row className="piece second">
              <img src={forbiddenIcon} alt="" />
              <div className="view">
                <div className="title">禁用会话保持</div>
                <div>启用之后，系统不记录登录状态，当用户上一次操作完成退出浏览器后，需要重新登录。</div>
              </div>
              <Switch
                className="switch"
                checked={userSetting.autoExit}
                onChange={this.changeAutoExit}/>
            </Row>
          </MaterialModal>
          <MaterialModal
            className="auto-exit-confirm-modal"
            title="禁用会话保持提示"
            visible={this.state.showAutoExit}
            footer={(
              <Row type="flex" justify="end" align="middle">
                <button className="cancel-btn" onClick={() => this.closeModal("showAutoExit")}>放弃启用</button>
                <button className="ok-btn" onClick={this.openAutoExit}>
                  确认启用
                </button>
              </Row>
            )}
            width={640}
          >
            <img
              className="pgx-modal-close"
              src={closeIcon}
              alt="关闭对话框"
              onClick={()=>this.closeModal("showAutoExit")}
            />
            <Row
              className="content"
              type="flex"
              justify="space-between"
              align="top"
            >
              <img className="warning-icon" src={dataWarningIcon} alt="" />
              <div className="text">
                <p>如果启用该选项，浏览器关闭之后，再次访问需要重新验证身份。确认启用该选项？</p>
                <p>请注意：</p>
                <Row className="no-wrap" type="flex" justify="start" align="top">
                  <p>•&nbsp;</p>
                  <p> 需要退出当前账号并重新登录，该改动才会生效。</p>
                </Row>
                <Row className="no-wrap" type="flex" justify="start" align="top">
                  <p>•&nbsp;</p>
                  <p> 如果您使用 Chrome 浏览器，需要取消“关闭 Google Chrome 后继续运行后台应用”，并确保
                     “启动时”的配置不是“从上次停下的地方继续”，该功能才能生效。</p>
                </Row>
                <Row className="no-wrap" type="flex" justify="start" align="top">
                  <p>•&nbsp;</p>
                  <p> 如果您使用 Mac 系统，关闭浏览器后进程并没有结束，需要手动退出该浏览器才能生效。</p>
                </Row>
              </div>
            </Row>
          </MaterialModal>
          <MaterialModal
            className="account-info-modal"
            title="账户信息"
            visible={this.state.showBindInfo}
            footer={null}
            width={640}
          >
            <img
              className="pgx-modal-close"
              src={closeIcon}
              alt="关闭对话框"
              onClick={()=>this.closeModal("showBindInfo")}
            />
            <Row type="flex" justify='start' align='middle' className='subtitle'>
              <i></i>
              <div>账户基础信息</div>
            </Row>
            <Form>
              <MaterialFormItem labelText="用户名" labelWidth={62}>
                {userInfo.username}
              </MaterialFormItem>
              <MaterialFormItem labelText="所在机构" labelWidth={62}>
                {userInfo.orgName}
              </MaterialFormItem>
            </Form>
            <div className="bottom-line"></div>
            {
              userInfo.phone
                ? (
                    <div>
                      <Row type='flex' justify='start' align='middle' className='subtitle'>
                        <i></i>
                        <div>手机绑定 </div>
                      </Row>
                      <MaterialFormItem
                        labelWidth={62}
                        labelText="手机号码"
                        inputType="phone"
                        tipMsgType={legitimacy.phone.tipMsgType}
                      >
                        <div>{userInfo.phone}</div>
                      </MaterialFormItem>
                    </div>
                )
                : (
                    <div>
                      <Row type='flex' justify='start' align='middle' className='subtitle'>
                        <i></i>
                        <div>手机绑定 </div>
                        <img src={dataWarningIcon} alt="" />
                        <div>为了您的账户安全，请尽快绑定手机号码。</div>
                      </Row>
                      <Form className="bind-phone">
                        <MaterialFormItem
                          labelWidth={62}
                          labelText="手机号码"
                          inputType="phone"
                          tipMsgType={legitimacy.phone.tipMsgType}
                        >
                          <Row type="flex" justify="start" align='middle'>
                            <Input name="phone" type="text"
                                   className="phone-input"
                                   value={bindInfoData.phone || ""}
                                   onChange={(e) => this.changeBindInfoData(e, "phone")}
                                   placeholder="请输入您的手机号码"
                                   onBlur={() => this.checkLegitimacy("phone")}
                                   onFocus={() => this.clearLegitimacyError("phone")}
                             />
                          </Row>
                        </MaterialFormItem>
                        <MaterialFormItem
                          labelText="验证码"
                          inputType="code"
                          tipMsgType={legitimacy.code.tipMsgType}
                          labelWidth={62}
                        >
                          <Input name="phone" type="text"
                                 className="code-input"
                                 value={bindInfoData.code || ""}
                                 onChange={(e) => this.changeBindInfoData(e, "code")}
                                 placeholder="请输入接收的验证码"
                                 onFocus={() => this.clearLegitimacyError("code")}
                                 onBlur={() => this.checkLegitimacy("code")}
                          />
                          <button
                            className={codeBtnClass}
                            onClick={this.sendCode}>{isReadySendCode
                              ? "发送验证码"
                              : `重新发送(${waitSecond}S)`}
                          </button>
                        </MaterialFormItem>
                      </Form>
                      <footer>
                        <button className="confirm-bind cursor-p" onClick={this.confirmBind}>确认绑定</button>
                        <button className="cancel cursor-p" onClick={()=>this.closeModal("showBindInfo")}>取消</button>
                      </footer>
                    </div>
                )
            }
          </MaterialModal>
        </header>
    )
  }
}

@inject("auth")@observer
class ChangePasswordModal extends Component {
  state = {
    oldPassword: "",
    newPassword: "",
    rePassword: ""
  }

  updateField = (e, field) => {
    this.setState({
      [field]: e.target.value
    })
  }

  confirmChange = (e) =>{
    let { oldPassword, newPassword, rePassword } = this.state
    if(newPassword === rePassword){
      this.props.auth.setPassword({oldPassword, newPassword})
      .then(() => {
        message.success("密码修改成功")
        this.props.onClose()
      }, error => {
        message.error(error.message)
      })
    } else {
      message.error("两次输入的新密码不一致，请重新输入！")
    }
  }

  render () {
    const { onClose } = this.props
    const { oldPassword, newPassword, rePassword } = this.state

    return (
      <MaterialModal
        className="repassowrd-modal"
        title="修改密码"
        visible
        action={this.confirmChange}
      >
        <img
          className="pgx-modal-close"
          src={closeIcon}
          alt="关闭对话框"
          onClick={onClose}
        />
        <MaterialForm justify="center">
          <MaterialFormItem
            labelText="老密码"
            labelWidth={60}
          >
            <Input
              className="repassowrd-input"
              name="oldPassword" type="password"
              value={oldPassword}
              onChange={(ev) => this.updateField(ev, "oldPassword")}
              placeholder="老密码" />
          </MaterialFormItem>
          <MaterialFormItem
            labelWidth={60}
            labelText="新密码"
            justify="center"
          >
            <Input
              className="repassowrd-input"
              name="newPassword"
              type="password"
              value={newPassword}
              onChange={(ev) => this.updateField(ev, "newPassword")}
              placeholder="新密码"/>
          </MaterialFormItem>
          <MaterialFormItem
            labelWidth={60}
            labelText="重复新密码"
            justify="center"
          >
            <Input
              className="repassowrd-input"
              name="rePassword"
              type="password"
              value={rePassword}
              onChange={(ev) => this.updateField(ev, "rePassword")}
              placeholder="重复新密码"/>
          </MaterialFormItem>
        </MaterialForm>
      </MaterialModal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/common/Header/index.js